export const elevareSkills = [
  {
    title: "Career Skills",
    description: "Essential professional skills for workplace success",
    icon: "💼",
    features: ["Communication", "Teamwork", "Leadership"]
  },
  {
    title: "Industry Projects",
    description: "Hands-on experience with real-world projects",
    icon: "🚀",
    features: ["Project work", "Case studies", "Portfolio building"]
  },
  {
    title: "Mentorship",
    description: "Guidance from industry professionals",
    icon: "👨‍💼",
    features: ["Industry mentors", "Career guidance", "Networking"]
  },
  {
    title: "Industry Demanded Courses",
    description: "Curriculum aligned with market needs",
    icon: "📚",
    features: ["Latest technologies", "Trending skills", "Market research"]
  },
  {
    title: "Interview Preparation",
    description: "Get ready for job interviews",
    icon: "🎯",
    features: ["Mock interviews", "Resume building", "Soft skills"]
  },
  {
    title: "Professional Development",
    description: "Continuous growth and skill enhancement",
    icon: "📈",
    features: ["Workshops", "Webinars", "Certifications"]
  }
];

export const elevareCourses = [
  {
    title: "Full Stack Web Development",
    description: "Comprehensive training in modern web development technologies.",
    icon: "💻",
    images: ["/images/courses/full-stack-web-development-1.webp", "/images/courses/full-stack-web-development-2.webp"],
    status: "Available Now",
    available: true,
    techs: ["HTML5 / CSS3 / Tailwind", "React.js & Router", "Node.js & Express", "MongoDB & REST APIs"]
  },
  {
    title: "Data Analytics",
    description: "Learn to analyze and interpret complex datasets.",
    icon: "📊",
    images: ["/images/courses/data-analytics-1.webp", "/images/courses/data-analytics-2.webp"],
    status: "Coming Soon",
    available: false,
    techs: ["SQL Databases", "Advanced Excel", "Tableau & PowerBI", "Python Data Science"]
  },
  {
    title: "Data Science",
    description: "Advanced statistical analysis and machine learning.",
    icon: "🔬",
    images: ["/images/courses/data-science-1.webp", "/images/courses/data-science-2.webp"],
    status: "Coming Soon",
    available: false,
    techs: ["Probability & Stats", "Machine Learning models", "Python Pandas & NumPy", "Deep Learning basics"]
  },
  {
    title: "Machine Learning",
    description: "Deep learning and AI algorithms.",
    icon: "🤖",
    images: ["/images/courses/machine-learning-1.webp", "/images/courses/machine-learning-2.webp"],
    status: "Coming Soon",
    available: false,
    techs: ["Supervised Learning", "Unsupervised Clustering", "Neural Networks", "NLP & CV Models"]
  },
  {
    title: "Business Analytics",
    description: "Data-driven decision making for business.",
    icon: "📈",
    images: ["/images/courses/business-analytics-1.webp", "/images/courses/business-analytics-2.webp"],
    status: "Coming Soon",
    available: false,
    techs: ["Predictive Analytics", "A/B Testing", "Financial Modeling", "Business Intelligence"]
  }
];

export const elevareFirstYearPrograms = [
  {
    title: "Basics of Web Development",
    description: "HTML + CSS + JavaScript fundamentals.",
    icon: "🌐",
    images: ["/images/courses/basics-of-web-development-1.webp", "/images/courses/basics-of-web-development-2.webp"],
    status: "Available Now",
    techs: ["Semantic Markup", "Responsive Flexbox/Grid", "DOM Manipulation"]
  },
  {
    title: "Python Programming",
    description: "Beginner-friendly introduction to Python.",
    icon: "🐍",
    images: ["/images/courses/python-programming-1.webp", "/images/courses/python-programming-2.webp"],
    status: "Available Now",
    techs: ["Core Syntax", "Data Structures", "Functional Coding"]
  },
  {
    title: "JavaScript",
    description: "Core JavaScript concepts and programming.",
    icon: "⚡",
    images: ["/images/courses/javascript-1.webp", "/images/courses/javascript-2.webp"],
    status: "Available Now",
    techs: ["ES6+ Features", "Asynchronous Calls", "API Integrations"]
  }
];

export const juniorCurriculum = [
  { 
    title: "Class 10th Subjects", 
    description: "Complete curriculum covering all subjects.", 
    icon: "📚",
    images: ["/images/courses/class-10th-subjects-1.webp", "/images/courses/class-10th-subjects-2.webp"],
    features: ["Mathematics", "Science (Physics, Chemistry, Biology)", "Languages (Hindi, Telugu, English)"]
  },
  { 
    title: "Intermediate (11th & 12th) MPC", 
    description: "Maths, Physics, Chemistry for engineering aspirants.", 
    icon: "🧪",
    images: ["/images/courses/intermediate-11th-12th-mpc-1.webp", "/images/courses/intermediate-11th-12th-mpc-2.webp"],
    features: ["Maths - 1A, 1B, 2A, 2B", "Physics", "Chemistry"]
  },
  { 
    title: "Intermediate (11th & 12th) BiPC", 
    description: "Biology, Physics, Chemistry for medical aspirants.", 
    icon: "🔬",
    images: ["/images/courses/intermediate-11th-12th-bipc-1.webp", "/images/courses/intermediate-11th-12th-bipc-2.webp"],
    features: ["Botany", "Zoology", "Physics, Chemistry"]
  },
  { 
    title: "EAPCET Entrance Prep", 
    description: "Comprehensive preparation for engineering and agriculture entrance.", 
    icon: "🎯",
    images: ["/images/courses/eapcet-entrance-prep-1.webp", "/images/courses/eapcet-entrance-prep-2.webp"],
    features: ["Engineering stream", "Agriculture stream", "Model papers & practice"]
  },
  { 
    title: "Foundation Programs", 
    description: "Building strong fundamentals for competitive exams.", 
    icon: "🏗️",
    images: ["/images/courses/foundation-programs-1.webp", "/images/courses/foundation-programs-2.webp"],
    features: ["Concept clarity", "Problem-solving skills", "Time management"]
  },
  { 
    title: "NEET Entrance Prep", 
    description: "Rigorous coaching and test series tailored specifically for medical (BiPC) students only.", 
    icon: "🩺",
    images: ["/images/courses/neet-entrance-prep-1.webp", "/images/courses/neet-entrance-prep-2.webp"],
    features: ["BiPC Students Only", "Advanced Biology (Botany & Zoology)", "Weekly NEET pattern test series"]
  }
];

export const businessPrograms = [
  { 
    title: "Business Planning", 
    description: "Learn to create comprehensive business plans.", 
    icon: "📝",
    images: ["/images/courses/business-planning-1.webp", "/images/courses/business-planning-2.webp"],
    features: ["Market analysis", "Financial projections", "Strategic planning"]
  },
  { 
    title: "Market Analysis", 
    description: "Understand market dynamics and opportunities.", 
    icon: "📊",
    images: ["/images/courses/market-analysis-1.webp", "/images/courses/market-analysis-2.webp"],
    features: ["Competitor research", "Consumer insights", "Trend analysis"]
  },
  { 
    title: "Leadership", 
    description: "Develop leadership and management skills.", 
    icon: "👑",
    images: ["/images/courses/leadership-1.webp", "/images/courses/leadership-2.webp"],
    features: ["Team building", "Decision making", "Communication"]
  },
  { 
    title: "Venture Capital", 
    description: "Learn about funding and investment strategies.", 
    icon: "💰",
    images: ["/images/courses/venture-capital-1.webp", "/images/courses/venture-capital-2.webp"],
    features: ["Pitch preparation", "Investor relations", "Funding options"]
  },
  { 
    title: "Digital Marketing", 
    description: "Master digital marketing strategies.", 
    icon: "📱",
    images: ["/images/courses/digital-marketing-1.webp", "/images/courses/digital-marketing-2.webp"],
    features: ["Social media", "SEO/SEM", "Content marketing"]
  },
  { 
    title: "Website/Web App Development for Startups", 
    description: "Custom web solutions for emerging businesses.", 
    icon: "🌐",
    images: ["/images/courses/website-web-app-development-for-startups-1.webp", "/images/courses/website-web-app-development-for-startups-2.webp"],
    features: ["Responsive design", "Startup-focused features", "Scalable architecture"]
  },
  { 
    title: "Mobile App Development", 
    description: "Native and cross-platform mobile applications.", 
    icon: "📱",
    images: ["/images/courses/mobile-app-development-1.webp", "/images/courses/mobile-app-development-2.webp"],
    features: ["iOS & Android apps", "Cross-platform solutions", "App store deployment"]
  }
];

export const businessTimeline = [
  {
    date: "Q1 2026",
    title: "Advanced Startup Incubator",
    description: "A comprehensive incubation program with mentorship, funding opportunities, and office space for promising startups.",
    icon: "🏢"
  },
  {
    date: "Q2 2026",
    title: "International Business Partnerships",
    description: "Opportunities to collaborate with international companies and expand your business globally.",
    icon: "🌍"
  },
  {
    date: "Q3 2026",
    title: "AI-Powered Business Analytics",
    description: "Advanced analytics tools powered by AI to help you make data-driven decisions for your business.",
    icon: "🤖"
  },
  {
    date: "Q4 2026",
    title: "Business Accelerator Program",
    description: "An intensive program to accelerate the growth of existing businesses with advanced strategies and resources.",
    icon: "🚀"
  }
];
